/**
 * Maps org prefix to full hospital display name.
 * Add new tenants here as they onboard.
 */
const HOSPITAL_NAME_MAP = {
  disha: "DISHA EYE HOSPITALS PRIVATE LIMITED",
  recc: "RENU EYE CARE CENTRE",
  secondsight: "SECOND SIGHT",
  SecondSight: "SECOND SIGHT",
};

/**
 * Returns the full hospital name for a given prefix.
 * Falls back to the prefix itself (upper-cased) if not in the map.
 */
export const getHospitalName = (prefix) => {
  if (!prefix) return "DISHA EYE HOSPITALS PRIVATE LIMITED";
  return (
    HOSPITAL_NAME_MAP[prefix] ||
    HOSPITAL_NAME_MAP[prefix.toLowerCase()] ||
    prefix.toUpperCase()
  );
};
